// extracted by mini-css-extract-plugin
export default {"button_primary":"button_button_primary__Fqiwn","button_dark":"button_button_dark__EOzEe","read_more":"button_read_more__5sAqq"};